<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <el-form label-position="top"
             label-width="45px"
             width="50%"
             :model="inServForm"
             :rules="dataRule"
             ref="inServForm">
      <!--面授课程 -->
      <!-- <el-row> -->
      <el-form-item label="" width="50%">
        <el-col :span="24">
          <span style="color: #abaeb5" >{{$t('offering.courseNameCncan')}}：</span>
          <span style="color: #abaeb5" >{{inServForm.courseNameCn}}</span>
        </el-col>
      </el-form-item>
      <!-- </el-row> -->
      <!--报名人数 -->
      <el-form-item label="" style="margin-top:10px;">
        <el-col :span="10">
          <span color="#abaeb5">{{$t('offering.registNumbercan')}}：</span>
          <span color="#abaeb5">{{inServForm.registNumber}}</span>
        </el-col>
      </el-form-item>
      <!--已加入等候名单 -->
      <el-form-item label="" style="margin-top:10px;">
        <el-col :span="10">
          <span color="#abaeb5">{{$t('offering.waitingnumbercan')}}：</span>
          <span color="#abaeb5">{{inServForm.waitingnumber}}</span>
        </el-col>
      </el-form-item>
      <!--培训日期 -->
      <el-form-item label="" style="margin-top:10px;">
        <el-col :span="24">
          <span color="#abaeb5">{{$t('offering.startdatecan')}}：</span>
          <span color="#abaeb5">{{inServForm.startdates}}</span>
        </el-col>
      </el-form-item>
      <!--地点 -->
      <el-form-item label="" style="margin-top:10px;">
        <el-col :span="24">
          <span color="#abaeb5">{{$t('offering.siteNamecan')}}：</span>
          <span color="#abaeb5">{{inServForm.siteName}}</span>
        </el-col>
      </el-form-item>
      <div class="line"></div>
      <div style="margin-top:10px;">
        <el-form-item label="" style="margin-top:10px;">
          <el-col :span="24">
            <el-form-item prop="cancelreasons" :label="$t('offering.cancereasons')" style="width: 60px;">
              <el-select v-model="inServForm.cancelreasons" style="width: 60px;"
                         filterable :placeholder="$t('offering.cancereasonselect')">
                <el-option v-for="(item,index) in cancelSchedule"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="" style="margin-top:10px;">
          <el-col :span="24">
            <el-form-item prop="cancelremarks" :label="$t('offering.canceremarks')" style="width: 60px;">
              <!-- <span slot="label">&nbsp;&nbsp;&nbsp;</span>  padding-left: 2.5px;-->
              <el-input type="textarea"
                        :maxlength="2000"
                        show-word-limit
                        v-model="inServForm.cancelremarks">
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="" style="margin-top:10px;">
          <div style="margin-top:20px;">
            <el-col :span="24">
              <!-- style="color:#000000" -->
              <span color="#abaeb5">* 排期取消后，该排期下所有资源将被释放</span>
              <!-- <span ></span> -->
            </el-col>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <!-- style="float:right; margin-bottom: 60px;" -->
    <!-- <el-col :span="16"><div class="grid-content" /></el-col> -->

    <div style="margin-top:20px;    width: 80% !important;">
      <el-button @click="btnSave(datalists)" :loading="loading" type="primary">提交</el-button>
      <ZElButton @click="closeCancelDlg()" :loading="loading" >{{ $t("course.cancel") }}</ZElButton>
    </div>
  </el-card>
</template>
<script>
  import ZElButton from '../../common/button/index'
  import debounce from 'lodash/debounce'
  export default {
    components: {
      ZElButton
    },
    props: {
      datalists: Object
    },
    data () {
      // let _this = this
      let _this = this
      return {
        loading: false,
        labelPosition: 'right',
        mixinViewModuleOptions: {
          activatedIsNeed: false,
          getDataListIsPage: true,
          deleteIsBatch: true
        },
        // 课程类型
        cancelSchedule: _this.enums['cancelSchedule'],
        // eslint-disable-next-line vue/no-dupe-keys
        currentRow: '',
        inServForm: {
          cancelremarks: '',
          cancelreasons: ''
        }
      }
    },
    computed: {
      dataRule () {
        return {
          cancelreasons: [{ type: 'string', required: true, message: this.$t('validate.required'), trigger: 'blur' }]
        }
      }
    },
    methods: {
      btnSave: debounce(function (data) {
        console.log(this.inServForm.cancelreasons)
        if (!this.inServForm.cancelreasons) { // === undefined || this.inServForm.cancelreasons === '' || this.inServForm.cancelreasons === '') {
          this.$message({
            message: this.$t('offering.cancelreasonstips'),
            type: 'error',
            duration: 5000,
            onClose: () => {
              console.log('onClose')
            }
          })
          return false
        }
        this.$confirm(
          this.$t('prompt.info', { handle: this.$t('offering.cancel') }),
          this.$t('prompt.title'),
          {
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel')
          }
        ).then(() => {
          this.loading=true
          this.$request.put('/learning/base/offeringinfo/cancel', {
            offeringId: data.offeringId,
            cancelremarks: this.inServForm.cancelremarks,
            cancelreasons: this.inServForm.cancelreasons
          }).then((res, total, code, data) => {
            this.loading = false
            if (data.code === 13000000) {
              let msg = ''
              if(data.msg='培训辅导付费功能上线准备中，此功能暂时无法使用。'){
                msg = data.msg
              }else{
              for (var i = 0; i < data.data.length; i++) {
                msg = msg + data.data[i]
              }
              }
              this.$message({
                message: msg,
                type: 'error',
                duration: 5000,
                onClose: () => {
                  console.log('onClose')
                }
              })
            } else if (data.code === 12000000) {
              this.$message({
                message: data.msg,
                type: 'error',
                duration: 5000,
                onClose: () => {
                  console.log('onClose')
                }
              })
            } else {
              this.$message({
                message: this.$t('prompt.success'),
                type: 'success',
                duration: 1000,
                onClose: () => {
                  // this.getDataList()
                }
              })
              this.$emit('closeCancelDlg')
            }
          }).catch(() => {  this.loading = false})
        }).catch(() => { this.loading = false })
      }),
      // 关闭dialog
      closeCancelDlg () {
             this.$emit('closeCancelDlg')
      },
      getDealerBeforeGetInfo (datalist) {
        this.inServForm={
         cancelremarks: '',
          cancelreasons: ''}
        this.inServForm.cancelremarks = datalist.cancelremarks
        this.inServForm.cancelreasons = datalist.cancelreasons
        this.inServForm.courseNameCn = datalist.courseNameCn
        this.inServForm.registNumber = datalist.registNumber + '/' + datalist.maxNumber
        this.inServForm.startdates = this.dateFormat(datalist.startdate) + ' - ' + this.dateFormat(datalist.enddate)
        this.inServForm.waitingnumber = datalist.waitingnumber
        this.inServForm.siteName = datalist.siteName
      },
      dateFormat (cellValue) {
        let datetime = cellValue
        if (datetime) {
          const date = datetime.replace(/-/g, '/');
          datetime = new Date(date)
          let y = datetime.getFullYear() + '-'
          let mon = (datetime.getMonth() + 1) < 10 ? '0' + (datetime.getMonth() + 1) + '-' : (datetime.getMonth() + 1) + '-'
          let d = datetime.getDate() < 10 ? '0' + datetime.getDate() + ' ' : datetime.getDate() + ' '
          let h = datetime.getHours() < 10 ? '0' + datetime.getHours() + ':' : datetime.getHours() + ':'
          let min = datetime.getMinutes() < 10 ? '0' + datetime.getMinutes() : datetime.getMinutes()
          return y + mon + d + h + min
        }
        return ''
      }

    }
  }
</script>
<style lang="scss" scoped>
  .wrappDiv {
    .el-form-item__label {
      float: left;
    }
  }

  .el-row {
    margin-bottom: 1px;
  }
  .line {
    // height: 1px;
    // border-top: 1px solid #b2b0b4;
    // text-align: center;
    // margin: 1px;
    border-bottom: 1px dashed #ebeef5;
    padding-bottom: 8px;
  }
</style>
